import UploadProgressBar from 'app/components/UploadProgressBar';

const CustomersUploadProgressBar = props => {
  const {
    job,
    inModal
  } = props;

  let matchFileContext = {
    job_id: job.id,
    customersOnly: true
  }

  let total = job.expected_photo_count;
  let loaded = job.photo_count;

  return <UploadProgressBar {...{ matchFileContext, total, loaded, inModal }} />;
}

export default CustomersUploadProgressBar;
